import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  DomainFlattened,
  Juridiction,
  Ville,
  EntityType,
} from '../../entity/entity.types';
import { EntityCasesByJurisdiction } from '../../entity/expertises/EntityCasesByJurisdiction';
import { EntityDomains } from '../../entity/expertises/EntityDomains';
import { EntityCasesByCity } from '../../entity/expertises/EntityCasesByCity';
import { LawFirmKeywordsFetcher } from './LawFirmKeywordsFetcher';
import { EntityKeywords } from '../../entity/expertises/keywords/EntityKeywords';

type Props = {
  experience: {
    domains: Array<DomainFlattened>;
    juridictions: Array<Juridiction>;
    villes: Array<Ville>;
    decisionCount: number;
  };
  lawOfficeIdGroup: string;
  lawFirmName: string;
};

export class LawFirmCases extends React.Component<Props> {
  id = 'lawFirm-expertises';

  componentDidMount() {
    window.dispatchEvent(new CustomEvent('createNav', { detail: this.id }));
  }

  render() {
    const {
      lawOfficeIdGroup,
      lawFirmName,
      experience: { domains, juridictions, villes, decisionCount },
    } = this.props;
    const entityInfos: {
      entityId: string;
      entityName: string;
      entityType: EntityType;
    } = {
      entityId: lawOfficeIdGroup,
      entityName: lawFirmName,
      entityType: 'lawFirm',
    };
    return (
      <>
        <h2 id={this.id} className="entity__section-title">
          <FormattedMessage id="law-firm/page/LawFirmCases.tsx/1" />{' '}
          {lawFirmName}
        </h2>
        {domains.length > 0 && (
          <EntityDomains
            domains={domains}
            decisionCount={decisionCount}
            {...entityInfos}
          />
        )}
        {juridictions.length > 0 && (
          <EntityCasesByJurisdiction
            casesByJurisdiction={juridictions}
            decisionCount={decisionCount}
            {...entityInfos}
          />
        )}
        {villes.length > 0 && (
          <EntityCasesByCity
            casesByCity={villes}
            decisionCount={decisionCount}
            {...entityInfos}
          />
        )}
        <LawFirmKeywordsFetcher lawOfficeIdGroup={lawOfficeIdGroup}>
          {keywords =>
            keywords.length > 0 && (
              <EntityKeywords
                keywords={keywords}
                decisionCount={decisionCount}
                {...entityInfos}
              />
            )
          }
        </LawFirmKeywordsFetcher>
      </>
    );
  }
}
